export default [
  {
    path: 'master-item',
    redirect: { name: 'items' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'items',
        component: () => import('@pages/items/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Item',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Item',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'items-add',
        component: () => import('@pages/items/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Item',
          navActiveLink:'items',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Item',
              to: { name: 'items' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'items-edit',
        component: () => import('@pages/items/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Item',
          navActiveLink:'items',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Item',
              to: { name: 'items' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]